import { For, Stack } from '@chakra-ui/react'
import type { FC } from 'react'

import { EmptyState } from '@app/components/ui/empty-state'
import AIDashboardReportListItem from '@app/pages/aiDashboard/components/aiDashboardReportListItem'
import type { DashboardItem } from '@app/pages/aiDashboard/types'

interface Props {
  reports: DashboardItem[]
}

const AIDashboardReportList: FC<Props> = ({ reports }) => {
  if (!reports.length) {
    return (
      <EmptyState
        title="No reports"
        description="Create a new report to receive recurring updates on your companies strategy."
      />
    )
  }

  const sortedReports =
    reports?.sort((a, b) => (new Date(b?.createdAt).getTime() || 0) - (new Date(a?.createdAt).getTime() || 0)) || []

  return (
    <Stack>
      <For each={sortedReports}>{(report) => <AIDashboardReportListItem report={report} key={report.id} />}</For>
    </Stack>
  )
}

export default AIDashboardReportList
